<div class="overlay" (click)="close()"></div>

<div class="dialog">
  <div class="dialog-header">
    <div class="dialog-title">
      <span class="dialog-title__icon"><i class="fas fa-school"></i></span>
      <span>
        <strong>Switch School</strong>
        <small>{{ schools.length }} schools available</small>
      </span>
    </div>
    <button class="close-btn" (click)="close()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="dialog-search">
    <i class="fas fa-search"></i>
    <input type="text" [(ngModel)]="searchText" placeholder="Search school or admin..." />
    @if (searchText) {
      <button type="button" class="search-clear" (click)="searchText = ''">
        <i class="fas fa-times"></i>
      </button>
    }
  </div>

  <div class="dialog-body">
    @if (loading) {
      @for (i of [1,2,3]; track i) {
        <div class="school-skeleton"></div>
      }
    } @else if (schools.length === 0) {
      <div class="empty">
        <i class="fas fa-school"></i>
        <p>No schools found</p>
      </div>
    } @else if (filteredSchools.length === 0) {
      <div class="empty">
        <i class="fas fa-search"></i>
        <p>No matching schools</p>
      </div>
    } @else {
      @for (school of filteredSchools; track school.orgCode) {
        <div
          class="school-item"
          [class.selected]="selected?.orgCode === school.orgCode"
          [class.current]="currentOrgCode === school.orgCode"
          (click)="select(school)">
          <div class="school-avatar">
            @if (getSchoolLogo(school)) {
              <img [src]="getSchoolLogo(school)" [alt]="school.schoolName" (error)="handleLogoError(school)" />
            } @else {
              <span class="school-avatar__initials">{{ getInitials(school.schoolName) }}</span>
            }
          </div>
          <div class="school-info">
            <span class="school-name">{{ school.schoolName }}</span>
            <span class="school-meta">{{ school.employeeName }}</span>
          </div>
          @if (currentOrgCode === school.orgCode) {
            <span class="current-tag">Current</span>
          }
          @if (selected?.orgCode === school.orgCode) {
            <i class="fas fa-check-circle selected-icon"></i>
          }
        </div>
      }
    }
  </div>

  <div class="dialog-footer">
    <button class="btn-cancel" (click)="close()">Cancel</button>
    <button
      class="btn-switch"
      [disabled]="!selected || selected.orgCode === currentOrgCode"
      (click)="confirm()">
      <i class="fas fa-sync-alt"></i>
      Switch School
    </button>
  </div>
</div>
